<template>
  <div ref="myChart1" class="myChart1">

  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: "fenlei",
  components: {},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: ''
    }
  },
  watch: {},
  mounted() {
    this.lines()
  },
  methods: {
    lines() {
      window.addEventListener('resize', this.lines)
      let myChart = this.$echarts.init(this.$refs.myChart1);
      var img ='data:image/png;base64,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';
      var trafficWay = [
        {
          name: '现金',
          value: 20
        }, {
          name: '银联',
          value: 10
        }, {
          name: '微信',
          value: 30
        }, {
          name: '优惠券',
          value: 30
        }, {
          name: '支付宝',
          value: 30
        }];
      var height = this.$refs.myChart1.offsetHeight*0.5;
      var data = [];
      var color = [
        'rgba(30, 142, 250, 1)',
        'rgba(224, 60, 59, 1)',
        'rgba(39, 218, 98, 1)',
        'rgba(225, 114, 61, 1)',
        'rgba(31, 209, 255, 1)']
      for (var i = 0; i < trafficWay.length; i++) {
        data.push({
          value: trafficWay[i].value,
          name: trafficWay[i].name,
          itemStyle: {
            normal: {
              borderWidth: 5,
              shadowBlur: 10,
              borderColor: color[i],
              shadowColor: color[i]
            }
          }
        });
      }
      var seriesOption = [
        {
          name: '',
          type: 'pie',
          clockWise: false,
          radius: ['60%', '60%'],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              color: function (params) {
                return color[params.dataIndex]
              },
              label: {
                show: true,
                position: 'outside',
              },
              labelLine: {
                length: 20,
                length2: 20,
                show: true,
              }
            }
          },
          data: data
        }];
      var option = {
        color: 'rgba(101, 206, 220, 1.00)',
        graphic: {
          elements: [{
            type: "image",
            z: 3,
            style: {
              image: img,
              width: height,
              height: height
            },
            left: 'center',
            top: 'center',
            position: [10, 10]
          }]
        },
        tooltip: {
          show: true
        },
        // legend: {
        //   icon: "circle",
        //   orient: 'horizontal',
        //   data: ['现金', '银联', '微信', '优惠券', '支付宝'],
        //   right: 0,
        //   bottom: 0,
        //   align: 'right',
        //   textStyle: {
        //     color: "#fff"
        //   },
        //   itemGap: 0
        // },
        legend: [
          {
            type: "scroll",
            orient: 'horizontal',
            icon: 'circle',
            align: 'left',
            bottom: '0',
            itemGap: 20,
            textStyle: {
              color: "#fff"
            },
            data: ['现金', '银联', '微信', '优惠券', '支付宝'],
          }],
        toolbox: {
          show: false
        },
        series: seriesOption
      };
      myChart.clear();
      myChart.resize();
      myChart.setOption(option);
    },
  }
}
</script>

<style lang="scss" scoped>
.myChart1 {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
